import * as Types from './messaging_gql.generated';

import { MessageFragment, ConversationFragment, CoachFragment, MemberFragment } from './fragments.generated';
import { gql } from 'graphql.macro';
import { MessageFragmentDoc, ConversationFragmentDoc, CoachFragmentDoc, MemberFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
export type NewMessageMutationVariables = Types.Exact<{
  conversationUuid: Types.Scalars['UUID'];
  content: Types.Scalars['String'];
}>;


export type NewMessageMutation = (
  { __typename?: 'Mutations' }
  & { newMessage?: Types.Maybe<(
    { __typename?: 'SendMessage' }
    & Pick<Types.SendMessage, 'ok'>
    & { message?: Types.Maybe<(
      { __typename?: 'MessageNode' }
      & MessageFragment
    )> }
  )> }
);


export const NewMessageDocument = gql`
    mutation NewMessage($conversationUuid: UUID!, $content: String!) {
  newMessage(conversationUuid: $conversationUuid, content: $content) {
    ok
    message {
      ...message
    }
  }
}
    ${MessageFragmentDoc}`;
export type NewMessageMutationFn = Apollo.MutationFunction<NewMessageMutation, NewMessageMutationVariables>;
export type NewMessageMutationResult = Apollo.MutationResult<NewMessageMutation>;
export type NewMessageMutationOptions = Apollo.BaseMutationOptions<NewMessageMutation, NewMessageMutationVariables>;